import * as React from "react";
import { SVGProps } from "react";

const LoomNetwork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="_\xCE\xD3\xC8_1"
    data-name="\u2014\xCE\xD3\xC8_1"
    viewBox="0 0 160 141"
    {...props}
  >
    <defs>
      <style>{".cls-2{fill:#02819b}"}</style>
    </defs>
    <path
      fill="#4bc0c8"
      d="M121.42 141.18 12.1 64.44a28.32 28.32 0 0 1 0-46.39L38.58-.45 147.9 76.3a28.33 28.33 0 0 1 0 46.39ZM38.57 11.89 17.93 26.33a18.21 18.21 0 0 0 0 29.84l103.52 72.67 20.64-14.43a18.22 18.22 0 0 0 0-29.84Z"
    />
    <path
      d="M38.47 128.77 17.86 114.3a18.22 18.22 0 0 1 0-29.84l53.35-37.3-8.8-6.16-50.32 35.18a28.32 28.32 0 0 0 0 46.39l26.41 18.54 32.67-22.86-8.8-6.18ZM147.95 18.16 121.53-.38 88.83 22.5l8.8 6.18L121.52 12l20.62 14.47a18.22 18.22 0 0 1 0 29.84L88.78 93.58l8.8 6.18 50.33-35.21a28.32 28.32 0 0 0 0-46.39Z"
      className="cls-2"
    />
    <path
      d="M16.69 56.3h50.74v10.11H16.69z"
      className="cls-2"
      transform="rotate(-34.98 42.053 61.342)"
    />
    <path
      d="m136.76 60-20.25 14.18 5.79 8.28 21-14.71c-2.2-2.54-4.37-5.14-6.54-7.75Z"
      className="cls-2"
    />
  </svg>
);

export default LoomNetwork;
